import { ROUTE_NAMES } from '@/lib/enums';
import { ROLE_ADMIN } from '@/util/roles';

export const routes = [
	{
		path: 'company/:company_uuid',
		meta: {
			requireAuth: true,
			breadcrumb: 'Company',
		},
		children: [
			{
				path: '',
				name: ROUTE_NAMES.DEPOT.COMPANY.VIEW_COMPANY,
				component: () => {
					return import('@/views/depot/company/View-Company.vue');
				},
				meta: {
					requireAuth: true,
					breadcrumb: '',
				},
			},
			{
				path: 'sites',
				name: ROUTE_NAMES.DEPOT.COMPANY.VIEW_SITES,
				component: () => {
					return import('@/views/depot/company/View-Sites.vue');
				},
				meta: {
					requireAuth: true,
					breadcrumb: 'Sites',
				},
			},
			{
				path: 'site/:site_uuid',
				children: [
					{
						path: '',
						name: ROUTE_NAMES.DEPOT.COMPANY.SITES.VIEW_SITE,
						component: () => {
							return import('@/views/depot/company/site/View-Site.vue');
						},
						meta: {
							requireAuth: true,
							breadcrumb: 'Site',
						},
					},
					{
						path: 'rename',
						name: ROUTE_NAMES.DEPOT.COMPANY.SITES.RENAME_SITE,
						component: () => {
							return import('@/views/depot/company/site/Rename-Site.vue');
						},
						meta: {
							requireAuth: true,
							breadcrumb: 'Rename Site',
							minRole: ROLE_ADMIN,
						},
					},
				],
			},
			{
				path: 'rename',
				name: ROUTE_NAMES.DEPOT.COMPANY.RENAME_COMPANY,
				component: () => {
					return import('@/views/depot/company/Rename-Company.vue');
				},
				meta: {
					requireAuth: true,
					breadcrumb: 'Rename Company',
					minRole: ROLE_ADMIN,
				},
			},
		],
	},
];
